import { ScopeOfWork, ScopeOfWorkStatus } from "@/api/williams/scopesOfWork";

const StatusText: Record<number, string> = {
  [ScopeOfWorkStatus.New]: "New",
  [ScopeOfWorkStatus.Partial]: "Partial",
  [ScopeOfWorkStatus.Active]: "Active",
  [ScopeOfWorkStatus.SentToAconex]: "Sent to Aconex",
  [ScopeOfWorkStatus.Closed]: "Closed",
  [ScopeOfWorkStatus.Cancelled]: "Cancelled",
  [ScopeOfWorkStatus.Old]: "Old",
};

export function getStatusText(status: ScopeOfWorkStatus) {
  return StatusText[status];
}

export function getScopeOfWorkStatus(scope: ScopeOfWork) {
  if (
    scope.status === ScopeOfWorkStatus.Cancelled ||
    scope.status === ScopeOfWorkStatus.Closed ||
    scope.status === ScopeOfWorkStatus.SentToAconex
  ) {
    return scope.status;
  }

  if (scope.project === null) {
    return ScopeOfWorkStatus.New;
  } else if (!scope.welders) {
    return ScopeOfWorkStatus.Partial;
  } else if (scope.welders.length > 0) {
    return ScopeOfWorkStatus.Active;
  } else {
    return scope.status;
  }
}
